<script setup>
// AC-Group-Patch: Rollen & Rechte (glue-RBAC) eingebettet, mit Login-Token für die Rechteprüfung.
import { computed } from "vue";
import { useStore } from "vuex";
const store = useStore();
const src = computed(() => {
  const t = store.getters.getCurrentUser?.access_token || "";
  return "/glue/admin/roles/ui?cwt=" + encodeURIComponent(t);
});
</script>

<template>
  <div class="flex flex-col w-full h-full bg-n-background">
    <iframe :src="src" title="Rollen & Rechte" class="flex-1 w-full border-0" style="min-height: 100vh" />
  </div>
</template>
